import { useEffect, useState } from "react";
import SideTitle from "../SideTitle";

interface GifWithPngFallbackProps {
  srcBase: string; // without extension, e.g. "/assets/writing-wizard"
  alt: string;
  className?: string;
  playing?: boolean; // externally controlled autoplay
  onHoverChange?: (hovered: boolean) => void; // notify parent
  idleMode?: "png" | "title"; // what to render when not playing
}

export function GifWithPngFallback({
  srcBase,
  alt,
  className,
  playing = false,
  onHoverChange,
}: GifWithPngFallbackProps) {
  const gifSrc = `${srcBase}.gif`;

  const [gifLoaded, setGifLoaded] = useState(false);
  const [hovered, setHovered] = useState(false);

  // Preload GIF so play on hover/autoplay is instant
  useEffect(() => {
    const img = new Image();
    img.onload = () => setGifLoaded(true);
    img.onerror = () => setGifLoaded(false);
    img.src = gifSrc;
  }, [gifSrc]);

  const shouldPlay = (hovered || playing) && gifLoaded;

  return (
    <div
      className={className}
      onMouseEnter={() => {
        setHovered(true);
        onHoverChange?.(true);
      }}
      onMouseLeave={() => {
        setHovered(false);
        onHoverChange?.(false);
      }}
      onFocus={() => {
        setHovered(true);
        onHoverChange?.(true);
      }}
      onBlur={() => {
        setHovered(false);
        onHoverChange?.(false);
      }}
      style={{ position: "relative" }}
    >
      {shouldPlay ? (
        <img src={gifSrc} alt={alt} className="object-cover w-full h-full" />
      ) : (
        <div className="absolute inset-0 flex items-center justify-center p-2">
          <SideTitle title={alt} intro={""} icon={undefined} />
        </div>
      )}
    </div>
  );
}

export default GifWithPngFallback;
